export default __webpack_public_path__ + "static/assets/med_gel_solid_02_f.f5c68375.png";